"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNominalSpacingValue = exports.getColorFor = void 0;
const utils_1 = require("@obvio/utils");
function getColorFor(name, theme) {
    const { primary, secondary, complementary, additional } = theme.colors;
    const colors = [primary, secondary, complementary, ...additional];
    return colors[(0, utils_1.fnv32a)(name) % colors.length];
}
exports.getColorFor = getColorFor;
const isNominalSpacingValue = (spacing) => {
    return ['rem', 'px'].some((v) => spacing === null || spacing === void 0 ? void 0 : spacing.endsWith(v));
};
exports.isNominalSpacingValue = isNominalSpacingValue;
